import {
  APP_PRODUCT_ROUTE,
  APP_CHECKOUT_ROUTE,
  APP_CUSTOM_HUB_ROUTE,
  APP_LANDING_PAGE_ROUTE,
  APP_BRAND_PLP_ROUTE,
  APP_CART_ROUTE,
  APP_USER_IDAM_REGISTER_ROUTE,
  APP_USER_IDAM_ADD_BUSINESS_PROFILE_ROUTE,
  USER_ADD_BUSINESS_ROUTE,
  APP_USER_VALIDATE_EMAIL_ROUTE,
  APP_USER_REGISTER_ROUTE,
  BUY_AGAIN_ROUTE,
  CHECKOUT_PAYMENT_PAGE_URL,
  CHECKOUT_REVIEW_PAGE_URL, CHECKOUT_THANK_YOU_PAGE_URL,
  APP_USER_PASSWORDLESS_SIGNUP_ROUTE,
  BLOCKED_ACCOUNT_PAGE,
} from '~shared/constants';
import { UrlUtils } from '~app/modules/generic/utils/url.utils';
export namespace PageDetectionUtil {
  export function isBlockedAccountPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${BLOCKED_ACCOUNT_PAGE}`);
  }
  export function isPasswordlessSignup(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_USER_PASSWORDLESS_SIGNUP_ROUTE}`);
  }
  export function isProductDetailsPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_PRODUCT_ROUTE}/`);
  }

  export function isCheckoutPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_CHECKOUT_ROUTE}/`);
  }

  export function isUserEmailValidationPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_USER_VALIDATE_EMAIL_ROUTE}`);
  }

  export function isSignupPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return (
      url.startsWith(`/${APP_USER_IDAM_REGISTER_ROUTE}`) ||
      url.startsWith(`/${APP_USER_IDAM_ADD_BUSINESS_PROFILE_ROUTE}`) ||
      url.startsWith(`/${APP_USER_REGISTER_ROUTE}/${USER_ADD_BUSINESS_ROUTE}`)
    );
  }

  export function isCartPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_CART_ROUTE}/`);
  }

  export function isProductListPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return UrlUtils.isProductListPage(url);
  }

  export function isHomePage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url === '/' || (url.startsWith('/?') && url.split('/?').length > 1);
  }

  export function isCustomCategoryHubPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${APP_CUSTOM_HUB_ROUTE}/`);
  }

  export function isLandingPagePage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${APP_LANDING_PAGE_ROUTE}/`);
  }

  export function isBuyAgainPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${BUY_AGAIN_ROUTE}`);
  }

  export function isBrandPLPPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${APP_BRAND_PLP_ROUTE}/`);
  }

  export function isPaymentPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${CHECKOUT_PAYMENT_PAGE_URL}`);
  }

  export function isReviewPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${CHECKOUT_REVIEW_PAGE_URL}`);
  }

  export function isThankYouPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${CHECKOUT_THANK_YOU_PAGE_URL}`);
  }

  function isValidUrl(url: string): boolean {
    if (!url) {
      console.warn('null URL provided');
      return false;
    }
    return true;
  }
}
